export const getUrlParameter = (searchParams: URLSearchParams, paramName: string) => {
  const value = searchParams.get(paramName);
  return value ? value : '';
};

export const getAllUrlParameter = (searchParams: URLSearchParams, paramName: string) => {
  return searchParams.getAll(paramName);
};
